import { JSX, useMemo } from "react";
import { Accordion } from "components/accordion/accordion";
import { Icons } from "components/icons/constants/icons";
import { AccordionStyle } from "components/accordion/accordion";
import { OrganizationEventList } from "components/contracts/organization-event-list/organization-event-list";
import { OrganizationEventSummaryRecord } from "models/view-models/contracts/organization-event-summary-record";
import { Spinner } from "components/spinner/spinner";
import { EventService } from "utilities/services/events/event-service";
import { useGetOrganizationEventList } from "data/data-access-hooks/organizations/organization-queries";
import "./organization-event-list-accordion.scss";
import { t } from "utilities/localization/t";

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const OrganizationEventListAccordion = ({
    organizationId,
    summary,
}: {
    organizationId?: number;
    summary: OrganizationEventSummaryRecord;
}): JSX.Element => {

    const {list: organizationEventList} = EventService.useOrganizationEventList();
        
    const { data: events, isLoading: isLoadingOrganizationEventList } = useGetOrganizationEventList(
        organizationEventList,
        organizationId!,
        summary.year!,
    );

    const summaryTitle = useMemo(() => {
        const yearTitle = summary?.year == null ? t("notYetScheduled") : `${summary?.year}`;
        return `${yearTitle} (${summary?.totalEvents} Events)`;
    }, [summary?.year, summary?.totalEvents]);

    return (
        <Accordion
            cssClassName="organization-event-list-accordion"
            chevronLeft
            closedChevron={Icons.ChevronRight}
            openChevron={Icons.ChevronDown}
            title={summaryTitle}
            style={AccordionStyle.Inverse}>
            {isLoadingOrganizationEventList ? <Spinner /> : <OrganizationEventList events={events || []} />}
        </Accordion>
    );
};

// -------------------------------------------------------------------------------------------------
// #endregion Component
// -------------------------------------------------------------------------------------------------

export default OrganizationEventListAccordion;
